<template>
    <div class="dat-wrapper">
        <depositRenderData
            :data="checkingAccountData"
            :view-button-text="viewButtonText"
            :bank-health="bankHealth"
            :has-error="hasError"
            :bonus-amount="true"
        />
    </div>
</template>
<script>
    import depositRenderData from './deposit-render-data.vue';
    import depositPaymentHelper from '~/helpers/deposit-account-api';

    export default {
        components: {
            depositRenderData,
        },
        props: ['viewButtonText', 'bankHealth'],
        data() {
            return {
                checkingAccountData: [],
                hasError: false,
            };
        },
        async mounted() {
            await depositPaymentHelper.depositAccountData('lt-rt-chk').then((response) => {
                if (response.status === true) {
                    this.checkingAccountData = response.data;
                } else {
                    this.hasError = true;
                }
            });
        },
    };
</script>
